//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum MovementAction {
	Charge = 0,
	Discharge = 1,
	Note = 2
}
